import {
  Autocomplete, Box, IconButton,
  MenuItem, Select, Table, TableBody,
  TableCell, TableHead, TableRow, TextField, Typography
} from '@mui/material'
import React, { useRef, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { COMMON_STYLE, NEW_DOC_EYE_TYPE, NEW_DOC_EYE_TYPE_NEW } from '../../../../Utility/Constants'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import DeleteIcon from '@mui/icons-material/Delete';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'

const UmaDocOcularHistory = React.forwardRef((data, ref) => {
  const listVal = data
  const [ocular, setOcular] = useState({
    selectedRadio: 'surgery',
    eyeList: NEW_DOC_EYE_TYPE_NEW,
    // surgery State
    surgeryData: [],
    surgerySuggestion: [],
    selectedSurgery: null,
    dupSurgeryData: '[]',
    // Contact Lens State
    contactLensData: [],
    contactLensSuggestion: [],
    dupContactLensData: '[]',
    // Others State
    othersData: [],
    othersSuggestion: [],
    dupOthersData: '[]',
    // Medication State
    medicationData: [],
    dupMedicationData: '[]',
    medicationSugesstion: [],
    loadScreen: false
  })
  const changedRef = useRef(false)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - OCULAR HISTORY`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - OCULAR HISTORY`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performOcularHistoryAction: () => {
      if (
        (JSON.stringify(ocular.surgeryData) !== ocular.dupSurgeryData) ||
        (JSON.stringify(ocular.contactLensData) !== ocular.dupContactLensData) ||
        (JSON.stringify(ocular.othersData) !== ocular.dupOthersData) ||
        (JSON.stringify(ocular.medicationData) !== ocular.dupMedicationData)
      ) {
        postOcularHistoryData()
      }
    }
  }))

  const apiCalls = async () => {
    await getSurgeryMedicationData()
    await getSurgerySuggData()
    await getContactLensSuggData()
    await getOthersSuggData()
    await getMedicationSuggData()
  }

  const getSurgerySuggData = async () => {
    try {
      let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY_SUR_SUGG + '?doctor_id=' + data?.props?.doctorID)
      if (response.data.status === 'success') {
        setOcular((prev) => ({ ...prev, surgerySuggestion: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getContactLensSuggData = async () => {
    try {
      let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY_CONTACT_LENS_SUGG + '?doctor_id=' + data?.props?.doctorID)
      if (response.data.status === 'success') {
        setOcular((prev) => ({ ...prev, contactLensSuggestion: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getOthersSuggData = async () => {
    try {
      let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY_OTHERS_SUGG + '?doctor_id=' + data?.props?.doctorID)
      if (response.data.status === 'success') {
        setOcular((prev) => ({ ...prev, othersSuggestion: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getMedicationSuggData = async () => {
    try {
      let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY_MED_SUGG + '?doctor_id=' + data?.props?.doctorID)
      if (response.data.status === 'success') {
        setOcular((prev) => ({ ...prev, medicationSugesstion: response.data.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getSurgeryMedicationData = async () => {
    try {
      let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY +
        '?patient_id=' + data?.props?.patient_id + '&appointment_id=' + data?.props?.appointment_id + '&doctor_id=' + data?.props?.doctorID
      )
      if (response.data.status === 'success') {
        let surgery = response?.data?.data?.surgery
        let contactLens = response?.data?.data?.contact_lens
        let others = response?.data?.data?.others?.map((item)=>{ return {...item, other_name : item?.lense_name}})
        let medication = response?.data?.data?.medication
        let medObj = { id: null, drug_name: "", years: null, months: null, days: null, comments: "" }
        let surObj = { id: null, reason: "", surgery_name: "", no_of_years: null, eye_type: null, months: null, days: null }
        let contactLensObj = { id: null, reason: "", lense_name: "", no_of_years: null, eye_type: null, months: null, days: null }
        let othersObj = { id: null, reason: "", other_name: "", no_of_years: null, eye_type: null, months: null, days: null }
        setOcular((prev) => ({
          ...prev,
          surgeryData: surgery?.length > 0 ? [...surgery, surObj] : [surObj],
          dupSurgeryData: surgery?.length > 0 ? JSON.stringify([...surgery, surObj]) : JSON.stringify([surObj]),
          contactLensData: contactLens?.length > 0 ? [...contactLens, contactLensObj] : [contactLensObj],
          dupContactLensData: contactLens?.length > 0 ? JSON.stringify([...contactLens, contactLensObj]) : JSON.stringify([contactLensObj]),
          othersData: others?.length > 0 ? [...others, othersObj] : [othersObj],
          dupOthersData: others?.length > 0 ? JSON.stringify([...others, othersObj]) : JSON.stringify([othersObj]),
          medicationData: medication?.length > 0 ? [...medication, medObj] : [medObj],
          dupMedicationData: medication?.length > 0 ? JSON.stringify([...medication, medObj]) : JSON.stringify([medObj]),
          loadScreen: true
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postOcularHistoryData = async () => {
    try {
      let medicationList = ocular.medicationData?.filter(item => item?.drug_name)
      let surgeryList = ocular.surgeryData?.filter(item => item?.surgery_name)
      let contactLensList = ocular.contactLensData?.filter(item => item?.lense_name)
      let othersList = ocular.othersData?.filter(item => item?.other_name)
      let list = {
        appointment_id: data?.props?.appointment_id,
        medication: medicationList,
        surgery: surgeryList,
        contact_lense: contactLensList,
        others: othersList
      }
      let response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getSurgeryMedicationData()
        await getSurgerySuggData()
        await getContactLensSuggData()
        await getOthersSuggData()
        await getMedicationSuggData()
        changedRef.current = false
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const deleteOcularHistoryData = async (item, index, type) => {
    try {
      if (item?.id) {
        let data = {
          medication_id: type === 'medication' ? item.id : null,
          surgery_id: type === 'surgery' ? item?.id : null,
          contact_lense_id: type === 'contactLens' ? item?.id : null,
          others_id: type === 'others' ? item?.id : null,
          doctor_id: listVal?.props?.doctorID
        }
        let response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_OCULAR_HISTORY, data)
        if (response?.data?.status === 'success') {
          successMessage(response?.data?.message)
          await getSurgeryMedicationData()
        }
      } else {
        let surgeryData = [...ocular.surgeryData]
        let contactLensData = [...ocular.contactLensData]
        let othersData = [...ocular.othersData]
        let medicationData = [...ocular.medicationData]
        setOcular((prev) => {
          if (type === 'surgery') {
            if (index !== (ocular.surgeryData?.length - 1)) {
              surgeryData?.splice(index, 1)
            } else {
              surgeryData[index] = {
                ...surgeryData[index], id: null, reason: "", surgery_name: "",
                no_of_years: null, eye_type: null, months: null, days: null
              }
            }
          } else if (type === 'contactLens') {
            if (index !== (ocular.contactLensData?.length - 1)) {
              contactLensData?.splice(index, 1)
            } else {
              contactLensData[index] = {
                ...contactLensData[index], id: null, reason: "", lense_name: "",
                no_of_years: null, eye_type: null, months: null, days: null
              }
            }
          } else if (type === 'others') {
            if (index !== (ocular.othersData?.length - 1)) {
              othersData?.splice(index, 1)
            } else {
              othersData[index] = {
                ...othersData[index], id: null, reason: "", other_name: "",
                no_of_years: null, eye_type: null, months: null, days: null
              }
            }
          } else {
            if (index !== (ocular.medicationData?.length - 1)) {
              medicationData?.splice(index, 1)
            } else {
              medicationData[index] = {
                ...medicationData[index], id: null, drug_name: "",
                years: null, months: null, days: null, comments: ""
              }
            }
          }
          return { ...prev, surgeryData, contactLensData, othersData, medicationData }
        })
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const onChangeHandler = (newValue, key, index, type) => {
    try {
      setOcular((prev) => {
        let surgeryData = [...prev.surgeryData]
        let contactLensData = [...prev.contactLensData]
        let othersData = [...prev.othersData]
        let medicationData = [...prev.medicationData]
        switch (key) {
          case 'surgery_name':
            surgeryData[index] = { ...surgeryData[index], surgery_name: newValue }
            if (newValue !== '' && index === surgeryData.length - 1) {
              let obj = { id: null, reason: "", surgery_name: "", no_of_years: null, eye_type: null, months: null, days: null };
              surgeryData?.push(obj)
            }
            break;
          case 'lense_name':
            contactLensData[index] = { ...contactLensData[index], lense_name: newValue }
            if (newValue !== '' && index === contactLensData.length - 1) {
              let obj = { id: null, reason: "", lense_name: "", no_of_years: null, eye_type: null, months: null, days: null };
              contactLensData?.push(obj)
            }
            break;
          case 'other_name':
            othersData[index] = { ...othersData[index], other_name: newValue }
            if (newValue !== '' && index === othersData.length - 1) {
              let obj = { id: null, reason: "", other_name: "", no_of_years: null, eye_type: null, months: null, days: null };
              othersData?.push(obj)
            }
            break;
          case 'drug_name':
            medicationData[index] = { ...medicationData[index], drug_name: newValue }
            if (newValue !== '' && index === medicationData.length - 1) {
              let obj = { id: null, drug_name: "", years: null, months: null, days: null, comments: "" };
              medicationData?.push(obj)
            }
            break;
          default:
            if (type === 'surgery') {
              surgeryData[index] = { ...surgeryData[index], [key]: newValue }
            } else if (type === 'contactLens') {
              contactLensData[index] = { ...contactLensData[index], [key]: newValue }
            } else if (type === 'others') {
              othersData[index] = { ...othersData[index], [key]: newValue }
            } else {
              medicationData[index] = { ...medicationData[index], [key]: newValue }
            }
            break;
        }
        changedRef.current = true
        return { ...prev, surgeryData, contactLensData, othersData, medicationData }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderSurgeryScreen = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Surgery</TableCell>
                <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ocular.surgeryData?.length > 0 ? ocular.surgeryData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Autocomplete
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        freeSolo
                        clearIcon
                        size='small'
                        sx={{ width: '11dvw' }}
                        value={item.surgery_name || ''}
                        options={ocular.surgerySuggestion}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                        onChange={(e, newValue) => { onChangeHandler(newValue, 'surgery_name', index, 'surgery') }}
                        onInputChange={(e, newValue) => { onChangeHandler(newValue, 'surgery_name', index, 'surgery') }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Enter Surgery'
                            InputProps={{
                              ...params.InputProps, emed_tid: 'ocu_sur_name',
                              style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Select
                        size="small"
                        sx={{ width: '8dvw', height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }}
                        value={item?.eye_type || ''}
                        onChange={(e) => onChangeHandler(e.target.value, 'eye_type', index, 'surgery')}
                        inputProps={{ emed_tid: 'ocul_eye' }}
                        displayEmpty
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                      >
                        <MenuItem value="" disabled>Select Eye</MenuItem>
                        {ocular.eyeList.map((option, idx) => (
                          <MenuItem key={idx} value={option?.value}>{option?.label}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          size='small'
                          sx={{ width: '12dvw' }}
                          maxRows={5}
                          multiline
                          value={item?.reason}
                          onChange={(e) => {
                            let { value } = e.target
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS) {
                              onChangeHandler(value, 'reason', index, 'surgery')
                            }
                          }}
                          placeholder='Comments'
                          InputProps={{
                            emed_tid: 'ocu_reason',
                            style: item?.reason ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        />
                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='ocul_sur_dlt'
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          onClick={() => { deleteOcularHistoryData(item, index, 'surgery') }}
                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderContactLensScreen = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Contact Lens</TableCell>
                <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ocular.contactLensData?.length > 0 ? ocular.contactLensData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Autocomplete
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        freeSolo
                        clearIcon
                        size='small'
                        sx={{ width: '11dvw' }}
                        value={item.lense_name || ''}
                        options={ocular.contactLensSuggestion}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                        onChange={(e, newValue) => { onChangeHandler(newValue, 'lense_name', index, 'contactLens') }}
                        onInputChange={(e, newValue) => { onChangeHandler(newValue, 'lense_name', index, 'contactLens') }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Enter Contact Lens'
                            InputProps={{
                              ...params.InputProps, emed_tid: 'ocu_contact_lense_name',
                              style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Select
                        size="small"
                        sx={{ width: '8dvw', height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }}
                        value={item?.eye_type || ''}
                        onChange={(e) => onChangeHandler(e.target.value, 'eye_type', index, 'contactLens')}
                        inputProps={{ emed_tid: 'ocul_contact_lens_eye' }}
                        displayEmpty
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                      >
                        <MenuItem value="" disabled>Select Eye</MenuItem>
                        {ocular.eyeList.map((option, idx) => (
                          <MenuItem key={idx} value={option?.value}>{option?.label}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          size='small'
                          sx={{ width: '12dvw' }}
                          maxRows={5}
                          multiline
                          value={item?.reason}
                          onChange={(e) => {
                            let { value } = e.target
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS) {
                              onChangeHandler(value, 'reason', index, 'contactLens')
                            }
                          }}
                          placeholder='Comments'
                          InputProps={{
                            emed_tid: 'ocu_contact_lens_reason',
                            style: item?.reason ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        />
                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='ocul_contact_lens_dlt'
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          onClick={() => { deleteOcularHistoryData(item, index, 'contactLens') }}
                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderOthersScreen = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Others</TableCell>
                <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ocular.othersData?.length > 0 ? ocular.othersData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Autocomplete
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        freeSolo
                        clearIcon
                        size='small'
                        sx={{ width: '11dvw' }}
                        value={item.other_name || ''}
                        options={ocular.othersSuggestion}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                        onChange={(e, newValue) => { onChangeHandler(newValue, 'other_name', index, 'others') }}
                        onInputChange={(e, newValue) => { onChangeHandler(newValue, 'other_name', index, 'others') }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Enter Others'
                            InputProps={{
                              ...params.InputProps, emed_tid: 'ocu_other_name',
                              style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Select
                        size="small"
                        sx={{ width: '8dvw', height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }}
                        value={item?.eye_type || ''}
                        onChange={(e) => onChangeHandler(e.target.value, 'eye_type', index, 'others')}
                        inputProps={{ emed_tid: 'ocul_others_eye' }}
                        displayEmpty
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                      >
                        <MenuItem value="" disabled>Select Eye</MenuItem>
                        {ocular.eyeList.map((option, idx) => (
                          <MenuItem key={idx} value={option?.value}>{option?.label}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          size='small'
                          sx={{ width: '12dvw' }}
                          maxRows={5}
                          multiline
                          value={item?.reason}
                          onChange={(e) => {
                            let { value } = e.target
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS) {
                              onChangeHandler(value, 'reason', index, 'others')
                            }
                          }}
                          placeholder='Comments'
                          InputProps={{
                            emed_tid: 'ocu_others_reason',
                            style: item?.reason ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        />
                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='ocul_others_dlt'
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          onClick={() => { deleteOcularHistoryData(item, index, 'others') }}
                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderMedicationScreen = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Medication</TableCell>
                <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ocular.medicationData?.length > 0 ? ocular.medicationData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Autocomplete
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        freeSolo
                        clearIcon
                        size='small'
                        sx={{ width: '15dvw' }}
                        value={item.drug_name}
                        options={ocular.medicationSugesstion}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                        onChange={(e, newValue) => { onChangeHandler(newValue, 'drug_name', index, 'medication') }}
                        onInputChange={(e, newValue) => { onChangeHandler(newValue, 'drug_name', index, 'medication') }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Enter Medication'
                            InputProps={{
                              ...params.InputProps, emed_tid: 'ocul_med_name',
                              style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          size='small'
                          sx={{ width: '18dvw' }}
                          maxRows={5}
                          multiline
                          value={item?.comments}
                          onChange={(e) => {
                            let { value } = e.target
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS || value === '') {
                              onChangeHandler(value, 'comments', index, 'medication')
                            }
                          }}
                          placeholder='Comments'
                          InputProps={{
                            emed_tid: 'ocul_med_comments',
                            style: item?.comments ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                        />
                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }}
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          onClick={() => { deleteOcularHistoryData(item, index, 'medication') }}
                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={2}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apiCalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'}>
            <Typography className='doc_notes_header_card_font'>Ocular History</Typography>
            <Box component={'div'} display={'flex'}>
              {/* <RadioGroup
                row
                emed_tid='ocul_radio'
                value={ocular.selectedRadio}
                onChange={(e) => { setOcular((prev) => ({ ...prev, selectedRadio: e.target.value })) }}
              >
                <FormControlLabel value="surgery" control={<Radio size='small' />} label={<Typography className='doc_notes_header_card_font'>Surgery</Typography>} />
                <FormControlLabel value="medication" control={<Radio size='small' />} label={<Typography className='doc_notes_header_card_font'>Medication</Typography>} />
              </RadioGroup> */}
            </Box>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'}>
              <Typography className='doc_notes_header_card_font' mb={'0.5rem'}>Surgery</Typography>
              <Box component={'div'}>{renderSurgeryScreen()}</Box>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <Typography className='doc_notes_header_card_font' mb={'0.5rem'}>Contact Lens</Typography>
              <Box component={'div'}>{renderContactLensScreen()}</Box>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <Typography className='doc_notes_header_card_font' mb={'0.5rem'}>Others</Typography>
              <Box component={'div'}>{renderOthersScreen()}</Box>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <Typography className='doc_notes_header_card_font' mb={'0.5rem'}>Medication</Typography>
              <Box component={'div'}>{renderMedicationScreen()}</Box>
            </Box>
          </Box>
        </Box>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaDocOcularHistory
